import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export const ToolCard = ({
    id,
    image,
    title,
    description,
    loves,
    tags,
    url,
}) => {
    return (
        <Link to={`/tool/${title}`} className="group">
            <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden hover:border-blue-500 transition-colors">
                {/* Thumbnail */}
                <div className="w-full overflow-hidden">
                    <img
                        crossOrigin={
                            process.env.NODE_ENV === "development"
                                ? "anonymous"
                                : ""
                        }
                        src={image}
                        alt={title}
                        className="w-full h-auto object-cover group-hover:scale-105 transition-transform"
                    />
                </div>

                {/* Content */}
                <div className="p-4">
                    <h3 className="font-medium mb-2 group-hover:text-blue-600 transition-colors">
                        {title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                        {description}
                    </p>

                    {/* Tags */}
                    <div className="flex flex-wrap gap-2 mb-3">
                        {tags.map((tag, index) => (
                            <span
                                key={index}
                                className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>

                    {/* Loves */}
                    <div className="flex items-center gap-1 text-sm text-gray-500">
                        <Heart className="h-4 w-4" />
                        <span>{loves.toLocaleString()}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
};
